import React, { useMemo } from 'react'

import { equals } from 'ramda'

import { Select } from '@driftt/dds'

import { CHAT_REPORT_TYPES } from 'constants/playbooks'

interface PlaybookTypeSelectProps {
  selectedValue?: string[] | string
  onChange: (selectedValues: string[]) => void
}

const CHAT_PLAYBOOKS_TYPE = 'CHAT_PLAYBOOKS'

export const PlaybookTypeSelect = ({
  selectedValue,
  onChange,
}: PlaybookTypeSelectProps) => {
  const options = useMemo(
    () => [
      {
        label: 'Chat playbooks',
        value: CHAT_PLAYBOOKS_TYPE,
        items: CHAT_REPORT_TYPES,
      },
    ],
    []
  )

  const selected = useMemo(
    () =>
      equals(CHAT_REPORT_TYPES, selectedValue)
        ? options.find(({ value }) => value === CHAT_PLAYBOOKS_TYPE)
        : '',
    [selectedValue, options]
  )

  const handleUpdate = (option) => {
    return onChange(option.items)
  }

  return (
    <Select
      label="Select playbook type"
      placeholder="Select..."
      hideLabel
      options={options}
      value={selected}
      onChange={handleUpdate}
    />
  )
}
